import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { ExcelWriter } from "./excel-writer";
import { ExcelReader } from "./excel-reader";

/**
 * Main class for Excel operations - delegates to specialized modules
 */
export default class ExcelOperator {
  constructor(deliverables, steps, responsibles, stepsFulfillment, totalFulfillment) {
    this.deliverables = deliverables;
    this.steps = steps;
    this.responsibles = responsibles;
    this.stepsFulfillment = stepsFulfillment;
    this.totalFulfillment = totalFulfillment;
  }

  /**
   * Saves the current data as an Excel file
   */
  async saveAsExcel(props) {
    const workbook = new ExcelJS.Workbook();
    const writer = new ExcelWriter(workbook);

    await writer.generateWorksheet(props);

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Tasks.xlsx");
  }

  /**
   * Loads data from an Excel file
   */
  async loadExcel(props) {
    const reader = new ExcelReader();
    return await reader.loadFromFile(props.file);
  }
}
